var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "details",
        { staticClass: "card card--collapsible", attrs: { open: "" } },
        [
          _c(
            "summary",
            { staticClass: "card__title card__title--bg-primary" },
            [
              _c("h5", [
                _vm._v(_vm._s(_vm.titulo) + " # " + _vm._s(_vm.index + 1))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "form-inline" }, [
                  _c("label", { attrs: { for: "marcarTodas" + _vm.titulo } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.marcar,
                          expression: "marcar"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "marcarTodas" + _vm.titulo
                      },
                      domProps: {
                        checked: Array.isArray(_vm.marcar)
                          ? _vm._i(_vm.marcar, null) > -1
                          : _vm.marcar
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.marcar,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.marcar = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.marcar = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.marcar = $$c
                            }
                          },
                          _vm.marcarTodas
                        ]
                      }
                    }),
                    _c("span", [_vm._v("Marcar/Desmarcar todas")])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-responsive" },
              [
                _c("vue-good-table", {
                  attrs: {
                    columns: [
                      {
                        label: "Conciliado",
                        field: "conciliado",
                        filterable: false
                      },
                      {
                        label: "Fecha de consulta",
                        field: "fecha_inicio",
                        filterable: true
                      },
                      {
                        label: "Paciente",
                        field: "paciente.nombre_completo",
                        filterable: true
                      },
                      {
                        label: "Valor de consulta",
                        field: "valor_consulta",
                        filterable: true
                      },
                      {
                        label: "Valor a cancelar",
                        field: "valor_medico",
                        filterable: false
                      },
                      {
                        label: "",
                        field: "acciones"
                      }
                    ],
                    "pagination-options": {
                      enabled: false
                    },
                    rows: _vm.modelValue,
                    "search-options": {
                      enabled: false,
                      placeholder: "Buscar..."
                    },
                    styleClass: "vgt-table"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "table-row",
                      fn: function(props) {
                        return [
                          props.column.field === "acciones"
                            ? _c("span", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-info btn--text",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.verTxt(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-file" }),
                                    _c("span", [_vm._v("Descargar chat")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-warning btn--text",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.verZip(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-folder" }),
                                    _c("span", [_vm._v("Descargar archivos")])
                                  ]
                                )
                              ])
                            : props.column.field === "conciliado"
                            ? _c("span", [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for:
                                        "conciliada" + props.index + _vm.titulo
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.modelValue[
                                              props.row.originalIndex
                                            ].conciliada,
                                          expression:
                                            "modelValue[props.row.originalIndex].conciliada"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id:
                                          "conciliada" +
                                          props.index +
                                          _vm.titulo
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.modelValue[
                                            props.row.originalIndex
                                          ].conciliada
                                        )
                                          ? _vm._i(
                                              _vm.modelValue[
                                                props.row.originalIndex
                                              ].conciliada,
                                              null
                                            ) > -1
                                          : _vm.modelValue[
                                              props.row.originalIndex
                                            ].conciliada
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a =
                                              _vm.modelValue[
                                                props.row.originalIndex
                                              ].conciliada,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.modelValue[
                                                    props.row.originalIndex
                                                  ],
                                                  "conciliada",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.modelValue[
                                                    props.row.originalIndex
                                                  ],
                                                  "conciliada",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.modelValue[
                                                props.row.originalIndex
                                              ],
                                              "conciliada",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _c("span")
                                  ]
                                )
                              ])
                            : props.column.field === "paciente.nombre_completo"
                            ? _c("span", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-info btn--text",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.verPaciente(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(
                                      props.formattedRow[props.column.field]
                                    ) +
                                    "\n                      "
                                )
                              ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive mt-2" }, [
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v("Total de consultas (" + _vm._s(_vm.titulo) + ")")
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "Valor total en consultas (" + _vm._s(_vm.titulo) + ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "Valor final a cancelar (" + _vm._s(_vm.titulo) + ")"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _vm._v(
                        "\n                              " +
                          _vm._s(_vm.totalConsultas) +
                          "\n                          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                              " +
                          _vm._s(_vm.moneyFormat(_vm.valorTotalConsultas)) +
                          "\n                          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                              " +
                          _vm._s(_vm.moneyFormat(_vm.valorFinalCancelar)) +
                          "\n                          "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "paciente",
            scrollable: "",
            width: "80%",
            height: "auto"
          }
        },
        [
          _c("k-paciente", {
            on: {
              cancelar: function($event) {
                return _vm.$modal.hide("paciente")
              }
            },
            model: {
              value: _vm.selectedPaciente,
              callback: function($$v) {
                _vm.selectedPaciente = $$v
              },
              expression: "selectedPaciente"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3903ee1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3903ee1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/ItemCierrePago.vue
// module id = 591
// module chunks = 0